import { useSPIntl } from 'hooks/useIntl';
import { useMemo } from 'react';
import type { SolveResultFormat } from 'state/quotes/results/result.model';

export function useFormattedResult(value: number, format: SolveResultFormat) {
  const { formatNumber } = useSPIntl();
  const resultText = useMemo(() => {
    return formatNumber(value * (format === 'Percent' ? 100 : 1), { maximumFractionDigits: 4 });
  }, [format, formatNumber, value]);
  return resultText;
}
